export default __webpack_public_path__ + "media/images/delete-17f4001e7bc734581fa6da2866202320.png";